import "./Team.css";
import NavBar from "../Components/NavBar";
import Member_Card from "../Components/Member_Card";
import { useEffect, useState } from "react";

function Team()
{
    const [teamMembers, setTeamMembers] = useState([]);

    useEffect(() => {
        let url = "https://favapis.raganindustries.com/api_get_team_members.php";
        let headers = {
            "Content-type" : "application/json",
            "Accept" : "application/json"
        }
        fetch(url, {
            method : 'GET',
            headers : headers
        }).then((response) => response.json()).then((data) => {
            createTeamCards(data);
        });
    }, []);

    function createTeamCards(data)
    {
        let temp = [];
        for(let i in data)
        {
            temp.push(<Member_Card member_details = { data[i] } />)
        }
        setTeamMembers(temp);
    }

    return(
        <div className = "team">
            <NavBar />
            <div className = "team_container">
                <h1 className = "title" >Team Members</h1>
                <div className = "team_members">
                    { teamMembers }
                </div>
            </div>
        </div>
    );
}

export default Team;